// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"492":"82cc91b3","3328":"71fbf6da","4026":"80eae6e4","4044":"0bbae9ad","5674":"71fbf6da","6519":"9d239a65","8858":"71fbf6da"}[chunkId] + ".chunk.css";
};